import { TStaticPropsType } from 'core-components/sitebuilder/models/IWidget'

export const DEFAULT_TYPE = 'string'

export const BASE_STATIC_PROPS_TYPE_DATA: { key: TStaticPropsType; value: string }[] = [
  { key: 'string', value: 'String' },
  { key: 'number', value: 'Number' },
  { key: 'boolean', value: 'Boolean' },
]

export const STATIC_PROPS_TYPE_DATA: { key: TStaticPropsType; value: string }[] = [
  ...BASE_STATIC_PROPS_TYPE_DATA,
  { key: 'object', value: 'Object' },
  { key: 'array', value: 'Array' },
  { key: 'dropdown', value: 'Dropdown' },
  { key: 'multiselect', value: 'Multiselect' },
]
